export function buildMimicPath(
  currentPath: string,
  user: {
    email: string;
    company: string;
    name: string;
    companyId: string;
  }
) {
  return {
    pathname: currentPath.includes('admin') ? '/' : currentPath,
    search: `?mimicUser=${encodeURIComponent(
      user.email
    )}&mimicCompany=${encodeURIComponent(user.companyId)}`,
  };
}
